import { forEach, some } from 'lodash';
import { createSelector } from '@reduxjs/toolkit';

import type { StorytellerState } from 'store/StorytellerReduxState';
import { ComponentType } from 'types';

import Environment from 'StorytellerEnvironment';

/**
 * Top Level Selectors
 * These selectors are used so that you don't need to have knowledge of how
 * we are combining reducers. Each selector will return the entire
 * state of the reducer
 */
export const linkTipSliceSelector = (state: StorytellerState) => state.linkTipSlice;
export const storySaveStatusSelector = (state: StorytellerState) => state.storySaveStatus;
export const storyWithHistorySelector = (state: StorytellerState) => state.storyWithHistory;

export const dataSourceReducerSelector = (state: StorytellerState) =>
  storyWithHistorySelector(state).present.dataSourceReducer;

export const storyReducerSelector = (state: StorytellerState) =>
  storyWithHistorySelector(state).present.storyReducer;

export const storyReducerBlocksSelector = createSelector(
  storyReducerSelector,
  (storyState) => storyState.blocks,
);

export const storyReducerStoriesSelector = (state: StorytellerState) => storyReducerSelector(state).stories;

// UI selectors
export const getHasGlobalFilter = (state: StorytellerState) => {
  const blocks = storyReducerBlocksSelector(state);
  let blockIds;
  if (Environment.STORY_UID) {
    blockIds = storyReducerStoriesSelector(state)[Environment.STORY_UID].blockIds;
  }

  const hasGlobalFilter = some(blockIds, (blockId: string) => {
    const components = blocks[blockId].components;
    return components?.[0]?.type === ComponentType.GLOBAL_FILTER;
  });

  return hasGlobalFilter;
};

export const getGlobalFilterBlockId = (state: StorytellerState) => {
  const blocks = storyReducerBlocksSelector(state);
  let blockIds;
  let blockIdForGFB = '';
  if (Environment.STORY_UID) {
    blockIds = storyReducerStoriesSelector(state)[Environment.STORY_UID].blockIds;
  }

  forEach(blockIds, (blockId: string) => {
    const components = blocks[blockId].components;
    if (components?.[0]?.type === ComponentType.GLOBAL_FILTER) {
      blockIdForGFB = blockId;
    }
  });

  return blockIdForGFB;
};
